'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var pubsub = require('./pubsub.js');

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
(function(SessionCode2) {
  SessionCode2[SessionCode2["LOGGED_IN"] = 0] = "LOGGED_IN";
  SessionCode2[SessionCode2["EXPIRED"] = 1] = "EXPIRED";
  SessionCode2[SessionCode2["LOGGED_OFF"] = 2] = "LOGGED_OFF";
  SessionCode2[SessionCode2["TERMINATED_BY_ANOTHER_LOGIN"] = 3] = "TERMINATED_BY_ANOTHER_LOGIN";
  SessionCode2[SessionCode2["TERMINATED_BY_PRESET_TIME"] = 5] = "TERMINATED_BY_PRESET_TIME";
  SessionCode2[SessionCode2["TERMINATED_BY_SELF_EXCLUSION"] = 6] = "TERMINATED_BY_SELF_EXCLUSION";
  SessionCode2[SessionCode2["TERMINATED_BY_GEO_LOCATION"] = 7] = "TERMINATED_BY_GEO_LOCATION";
})(exports.SessionCode || (exports.SessionCode = {}));
class Events {
  constructor() {
    this.API2SDKTopicsMap = {
      balanceChanged: pubsub.Topic.BalanceChanged,
      achievement: pubsub.Topic.AchievementUnlocked,
      categoriesPublish: pubsub.Topic.CategoriesPublished,
      delayedReward: pubsub.Topic.DelayedReward,
      firstdeposit: pubsub.Topic.FirstDeposit,
      leaderboardPayout: pubsub.Topic.LeaderboardPayout,
      maintenance: pubsub.Topic.MaintenanceChanged,
      KYCUpdate: pubsub.Topic.KYCStatusUpdated,
      reward: pubsub.Topic.RewardReceived,
      relicPrizeAwarded: pubsub.Topic.RelicPrizeAwarded,
      sessionChange: pubsub.Topic.SessionChanged,
      subsequentdeposit: pubsub.Topic.SubsequentDeposit,
      translationsPublish: pubsub.Topic.TranslationsPublished,
      userUpdate: pubsub.Topic.UserUpdated,
      userDataRequired: pubsub.Topic.UserDataRequired,
      withdrawStatusChange: pubsub.Topic.WithdrawStatusChanged,
      wsConnected: pubsub.Topic.WSOpen,
      wsDisconnected: pubsub.Topic.WSClose,
      message: pubsub.Topic.Message,
      userBlockStatus: pubsub.Topic.UserBlockStatus,
      loyaltyPointsUpdate: pubsub.Topic.LoyaltyPointsUpdate,
      gameSessionSummary: pubsub.Topic.GameSessionSummary,
      lotbaUserSelfExcludedOnOldRegister: pubsub.Topic.LotbaUserSelfExcludedOnOldRegister,
      gameTransaction: pubsub.Topic.GameTransaction
    };
    this.sessionCodes2Topics = {
      [0]: pubsub.Topic.SessionCreated,
      [1]: pubsub.Topic.SessionExpired,
      [2]: pubsub.Topic.SessionLoggedOut,
      [3]: pubsub.Topic.SessionKickedOut,
      [5]: pubsub.Topic.SessionLimitationTimeReached,
      [6]: pubsub.Topic.SessionSelfExclusion,
      [7]: pubsub.Topic.SessionGeoLocation
    };
    this.legacyEvents = ["loggedIn"];
  }
  delayedReward(handler) {
    return pubsub.pubsub.subscribe(pubsub.Topic.DelayedReward, handler);
  }
  leaderboardPayout(handler) {
    return pubsub.pubsub.subscribe(pubsub.Topic.LeaderboardPayout, handler);
  }
  relicPrizeAwarded(handler) {
    return pubsub.pubsub.subscribe(pubsub.Topic.RelicPrizeAwarded, handler);
  }
  rewardReceived(handler) {
    return pubsub.pubsub.subscribe(pubsub.Topic.RewardReceived, handler);
  }
  subsequentDeposit(handler) {
    return pubsub.pubsub.subscribe(pubsub.Topic.SubsequentDeposit, handler);
  }
  firstDeposit(handler) {
    return pubsub.pubsub.subscribe(pubsub.Topic.FirstDeposit, handler);
  }
  achievementUnlocked(handler) {
    return pubsub.pubsub.subscribe(pubsub.Topic.AchievementUnlocked, handler);
  }
  maintenanceChanged(handler) {
    return pubsub.pubsub.subscribe(pubsub.Topic.MaintenanceChanged, handler);
  }
  userUpdated(handler) {
    return pubsub.pubsub.subscribe(pubsub.Topic.UserUpdated, handler);
  }
  userBlockStatusChanged(handler) {
    return pubsub.pubsub.subscribe(pubsub.Topic.UserBlockStatus, handler);
  }
  translationsPublished(handler) {
    return pubsub.pubsub.subscribe(pubsub.Topic.TranslationsPublished, handler);
  }
  categoriesPublished(handler) {
    return pubsub.pubsub.subscribe(pubsub.Topic.CategoriesPublished, handler);
  }
  userDataRequired(handler) {
    return pubsub.pubsub.subscribe(pubsub.Topic.UserDataRequired, handler);
  }
  KYCStatusUpdated(handler) {
    return pubsub.pubsub.subscribe(pubsub.Topic.KYCStatusUpdated, handler);
  }
  balanceChanged(handler) {
    return pubsub.pubsub.subscribe(pubsub.Topic.BalanceChanged, handler);
  }
  computedBalanceChanged(handler) {
    return pubsub.pubsub.subscribe(pubsub.Topic.BalanceChanged, (event) => {
      const newBalance = {
        balance: 0,
        realBalance: event.amount,
        bonusBalance: 0,
        bonusBonusMoneyBalance: 0,
        bonusRealMoneyBalance: 0
      };
      event.userBonus.forEach((product) => {
        newBalance.bonusBonusMoneyBalance += product.bonuses.reduce((prev, item) => prev + item.bonusMoney, 0);
        newBalance.bonusRealMoneyBalance += product.bonuses.reduce((prev, item) => prev + item.realBonusMoney, 0);
      });
      newBalance.bonusBalance = newBalance.bonusBonusMoneyBalance + newBalance.bonusRealMoneyBalance;
      newBalance.balance = newBalance.realBalance + newBalance.bonusBalance;
      handler(newBalance);
    });
  }
  withdrawStatusChanged(handler) {
    return pubsub.pubsub.subscribe(pubsub.Topic.WithdrawStatusChanged, handler);
  }
  sessionChange(handler) {
    return pubsub.pubsub.subscribe(pubsub.Topic.SessionChanged, handler);
  }
  sessionCreated(handler) {
    return pubsub.pubsub.subscribe(pubsub.Topic.SessionCreated, handler);
  }
  sessionDestroyed(handler) {
    return pubsub.pubsub.subscribe(pubsub.Topic.SessionDestroyed, handler);
  }
  sessionExpired(handler) {
    return pubsub.pubsub.subscribe(pubsub.Topic.SessionExpired, handler);
  }
  sessionKickedOut(handler) {
    return pubsub.pubsub.subscribe(pubsub.Topic.SessionKickedOut, handler);
  }
  sessionLimitationTimeReached(handler) {
    return pubsub.pubsub.subscribe(pubsub.Topic.SessionLimitationTimeReached, handler);
  }
  sessionSelfExclusion(handler) {
    return pubsub.pubsub.subscribe(pubsub.Topic.SessionSelfExclusion, handler);
  }
  sessionGeoLocation(handler) {
    return pubsub.pubsub.subscribe(pubsub.Topic.SessionGeoLocation, handler);
  }
  wsConnected(handler) {
    return pubsub.pubsub.subscribe(pubsub.Topic.WSOpen, handler);
  }
  wsDisconnected(handler) {
    return pubsub.pubsub.subscribe(pubsub.Topic.WSClose, handler);
  }
  message(handler) {
    return pubsub.pubsub.subscribe(pubsub.Topic.Message, (message) => {
      return handler(__spreadProps(__spreadValues({}, message), {
        created: message.created || new Date().toISOString()
      }));
    });
  }
  sowqRequested(handler) {
    return pubsub.pubsub.subscribe(pubsub.Topic.SOWQRequested, handler);
  }
  distribute(topic, payload) {
    const sdkTopic = this.API2SDKTopicsMap[topic];
    if (this.legacyEvents.includes(topic)) {
      return;
    }
    if (!sdkTopic) {
      return console.error(`Unknown topic: ${topic}`);
    }
    if (sdkTopic === pubsub.Topic.SessionChanged) {
      return this.distributeSessionEvent(payload);
    }
    pubsub.pubsub.publish(sdkTopic, payload);
  }
  loyaltyPointsUpdate(handler) {
    return pubsub.pubsub.subscribe(pubsub.Topic.LoyaltyPointsUpdate, handler);
  }
  gameSessionSummary(handler) {
    return pubsub.pubsub.subscribe(pubsub.Topic.GameSessionSummary, handler);
  }
  lotbaUserSelfExcludedOnOldRegister(handler) {
    return pubsub.pubsub.subscribe(pubsub.Topic.LotbaUserSelfExcludedOnOldRegister, handler);
  }
  gameTransaction(handler) {
    return pubsub.pubsub.subscribe(pubsub.Topic.GameTransaction, handler);
  }
  distributeSessionEvent(payload) {
    const sdkTopic = this.sessionCodes2Topics[payload.code];
    if (!sdkTopic) {
      return console.error(`Unknown session code: ${sdkTopic}`);
    }
    if (sdkTopic !== pubsub.Topic.SessionCreated && sdkTopic !== pubsub.Topic.SessionDestroyed) {
      pubsub.pubsub.publish(sdkTopic);
    }
    pubsub.pubsub.publish(pubsub.Topic.SessionChanged, payload.code);
  }
}
const events = new Events();

exports.Events = Events;
exports.events = events;
